module.exports = __webpack_public_path__ + "49f00693b0e5d45097832ef5ea1bc541.ttf";